export const sanitizeText = (value) =>
  String(value ?? '')
    .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '')
    .trim();

export const normalizeMultilineCell = (value) =>
  sanitizeText(value)
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .split('\n')
    .map((part) => part.trim())
    .filter(Boolean)
    .join(' | ');

export const normalizePdfText = (value) =>
  sanitizeText(value).replace(/₹/g, 'Rs.');

export const defaultCompanyName = () =>
  process.env.REACT_APP_COMPANY_NAME || process.env.BRAND_NAME || 'Company';

export const buildTimestampedFilename = (
  pageName,
  exportTypeSlug,
  extension,
  now = new Date()
) => {
  const day = String(now.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = monthNames[now.getMonth()];
  const year = now.getFullYear();
  let hours = now.getHours();
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  const hourStr = String(hours).padStart(2, '0');
  return `${pageName}-${exportTypeSlug}-${day}-${month}-${year}-${hourStr}-${minutes}${ampm}.${extension}`;
};
